import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MenuService } from '../core/services/menu.service';
import { HarvestingService } from '../core/services/harvesting.service';
import { AppConfigService } from '../core/services/app-config.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})


export class HomeComponent implements OnInit {


  constructor( 
    private menuService: MenuService,
    private harvestingService: HarvestingService,
    private router: Router,
    private appConfig: AppConfigService
  ) {}

  ngOnInit(): void {
  }

  onHarvestingNavigate() {
    const { acronym } = this.menuService.activeRepo.value;
    this.router.navigate([acronym, 'harvesting']);
  }

  onValidationNavigate() {
    const { acronym } = this.menuService.activeRepo.value;
    this.harvestingService.getHarvestingLastGoodKnowByAcronym(acronym).subscribe({
      next: ({ id }) => this.router.navigate([acronym, 'validation', id]),
      error: error => this.router.navigate([acronym, 'validation', error.status === 404 ? 0 : -1]),
    });
  }
  onStatisticsNavigate(){
    this.router.navigate(['statistics']);
  }

  isModuleActive( path: string ){
    return this.appConfig.getModuleStatus(path);

  }
}


  
